/* eslint-disable no-plusplus */
import jwtDecode from 'jwt-decode'
import _, { isEmpty, isEqual, xorWith } from 'lodash'
import moment from 'moment'
import { history } from 'redux/store'
import Colors from './Colors'

// Regular Expression to check if the input is CPF
const CPF_REGEX = /^[0-9.-]*$/
export const isNetworkError = (err) => {
  return err.isAxiosError && !err.response
}

export const extractOnlyNumbers = (cpf) => {
  return cpf.replace(/[^\d]/g, '')
}

export const isUserLogged = (token) => {
  if (_.isEmpty(token)) return false

  const decoded = jwtDecode(token)
  const currentTime = Date.now() / 1000
  return decoded.exp > currentTime
}

export const sleep = (m) => new Promise((r) => setTimeout(r, m))

export const isPasswordValid = (value) => {
  const regex = new RegExp(
    '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})',
  )
  return regex.test(value)
}

export const getExtensionFileName = (fileName) => {
  const ext = fileName.split('.').pop()
  return ext.split(/[^0-9a-z-_]/i)[0]
}

export const objToQueryString = (objQueryString) => {
  return _.chain(objQueryString)
    .pickBy((query) => !(_.isNil(query) || query === ''))
    .map((v, k) => `${k}=${v}`)
    .join('&')
    .value()
}

export const translateBoolean = (bool) => {
  switch (bool) {
    case true:
      return 'SIM'
    case false:
      return 'NAO'
    default:
      return bool
  }
}

export const maskString = (str, pattern) => {
  if (!str) return null
  const patterns = {
    cpf: '###.###.###-##',
    cnpj: '##.###.###/####-##',
    cnae: '##.##-#-##',
    phone: '(##)#####-####',
  }
  let i = 0
  return patterns[pattern].replace(/#/g, () => {
    return str[i++]
  })
}

export const buildScore = (score) => {
  if (score <= 3) return { color: Colors.green }

  if (score <= 11) return { color: Colors.orange }

  return { color: Colors.red }

}

export const buildRiskColor = (riskLevel) => {
  const colors = {
    'UNDEFINED': '#000',
    'LOW': Colors.green,
    'MEDIUM': Colors.orange,
    'HIGH': Colors.orange,
    'VERY_HIGH': Colors.red,
  }

  return colors[riskLevel]
}

export const buildRiskMessage = (riskLevel) => {
  const messages = {
    undefined: 'N/A',
    'UNDEFINED': 'Indefinido',
    'LOW': 'Baixo',
    'MEDIUM': 'Médio',
    'HIGH': 'Alto',
    'VERY_HIGH': 'Muito Alto',
  }

  return messages[riskLevel] || riskLevel
}

export const buildQuodScore = (score) => {
  if (score >= 700) {
    return { color: Colors.green }
  }

  if (score >= 400 && score <= 699) {
    return { color: Colors.orange }
  }

  return { color: Colors.red }
}

export const convertToBrazilianCurrency = (value) => {
  const number = value || 0
  return number.toLocaleString('pt-BR', { currency: 'BRL', style: 'currency' })
}

const dateFormats = [
  moment.ISO_8601,
  'MM/DD/YYYY',
  'DD/MM/YYYY',
  'YYYY/MM/DD',
  'MM-DD-YYYY',
  'DD-MM-YYYY',
  'YYYY-MM-DD',
  'dd.mm.yyyy',
]

export const formatInBrazilianDate = (date) => {
  return moment(date, dateFormats, true).format('DD/MM/YYYY')
}

export const formatInBrazilianDatetime = (date) => {
  return moment(date, dateFormats, true).format('DD/MM/YYYY hh:mm:ss')
}

export const isDate = (date) => {
  return moment(date, dateFormats, true).isValid()
}

export const hasAnswerChanged = (previousAnswer, currentAnswer) => {
  return !isEmpty(xorWith(previousAnswer, currentAnswer, isEqual))
}


export const isValidHttpUrl = (string) => {
  try {
    const newUrl = new URL(string)
    return newUrl.protocol === 'http:' || newUrl.protocol === 'https:'
  } catch (err) {
    return false
  }
}

export const gotoUrl = (url, from = undefined, email = undefined) => {
  history.push({ pathname: url, state: { from: from, email: email } })
  history.go()
}

/**
 * Checks if the user input matches the format of a CPF.
 *
 * @param {string} userInput - The user input to be checked.
 * @returns {boolean} Returns true if the user input matches the CPF format, otherwise, returns false.
 */
export const doesInputMatchCPFFormat = (userInput) => {
  return CPF_REGEX.test(userInput.trim())
}

/**
 * Returns the abbreviated name of the month for a given month number.
 * @param {number} month - The month number (1-12)
 * @returns {string} The abbreviated month name
 * @throws {Error} If the month is invalid
 */
export const monthToAbbr = (month) => {
  if (month >= 1 && month <= 12) {
    return moment.monthsShort()[month - 1]
  }
  
  throw new Error('Invalid month')
}


export const hasPermissionScope = (token, scope) => {
  const decoded = jwtDecode(token)
  return decoded.extras.scopes.includes(scope)
}

export const pointsText = (points) => (
  points === 1 ? `${points} ponto` : `${points} pontos`
)
